import {
  START_GET_COLLECTION_LIST,
  SUCCESS_GET_COLLECTION_LIST,
  ERROR_GET_COLLECTION_LIST,
  START_DELETE_COLLECTION,
  SUCCESS_DELETE_COLLECTION_GROUP,
  ERROR_DELETE_COLLECTION_GROUP,
  RESET_COLLECTION_STATE,
  START_GET_COLLECTION_COUNT,
  SUCCESS_GET_COLLECTION_COUNT,
  ERROR_GET_COLLECTION_COUNT,
  START_GET_COLLECTION_DETAIL,
  SUCCESS_GET_COLLECTION_DETAIL,
  ERROR_GET_COLLECTION_DETAIL,
  START_UPDATE_COLLECT_DATA,
  SUCCESS_UPDATE_COLLECT_DATA,
  ERROR_UPDATE_COLLECT_DATA,
  START_ADD_AND_UPDATE_NOTE,
  SUCCESS_ADD_AND_UPDATE_NOTE,
  ERROR_ADD_AND_UPDATE_NOTE,
  START_DELETE_NOTE,
  SUCCESS_DELETE_NOTE,
  ERROR_DELETE_NOTE,
  START_COLLECT_AND_REMOVE_MEDICATION,
  SUCCESS_COLLECT_AND_REMOVE_MEDICATION,
  ERROR_COLLECT_AND_REMOVE_MEDICATION,
  START_COLLECT_MARK_AS_URGENT,
  SUCCESS_COLLECT_MARK_AS_URGENT,
  ERROR_COLLECT_MARK_AS_URGENT,
  START_CREATE_RX,
  SUCCESS_CREATE_RX,
  ERROR_CREATE_RX,
  START_CREATE_CHASEUP,
  SUCCESS_CREATE_CHASEUP,
  ERROR_CREATE_CHASEUP,
  START_GET_PRINT_COLLECTION_LIST,
  SUCCESS_GET_PRINT_COLLECTION_LIST,
  ERROR_GET_PRINT_COLLECTION_LIST,
  START_DRUG_NAME_UPDATE,
  SUCCESS_DRUG_NAME_UPDATE,
  ERROR_DRUG_NAME_UPDATE,
  START_UPDATE_FIELD_COLLECTION,
  SUCCESS_UPDATE_FIELD_COLLECTION,
  ERROR_UPDATE_FIELD_COLLECTION,
  START_ARCHIVE_COLLECTION,
  SUCCESS_ARCHIVE_COLLECTION,
  ERROR_ARCHIVE_COLLECTION,
  START_COMPLETE_COLLECTION,
  SUCCESS_COMPLETE_COLLECTION,
  ERROR_COMPLETE_COLLECTION,
  START_COLLECTED_AND_REMOVED_MEDICATION,
  SUCCESS_COLLECTED_AND_REMOVED_MEDICATION,
  ERROR_COLLECTED_AND_REMOVED_MEDICATION,
  RESET_COLLECTED_AND_REMOVED_MEDICATION,
} from "Actions/CollectionAction";
import { SUCCESS_UPDATE_FIELD_PATIENT } from "Actions/PatientAction";

const initialState = {
  collectionRxList: {
    loading: false,
    data: {},
    error: "",
    success: false
  },
  deleteCollectionRx: {
    loading: false,
    data: {},
    error: {},
  },
  archiveCollectionRx: {
    loading: false,
    data: {},
    error: {},
  },
  completeCollectionRx: {
    loading: false,
    data: {},
    error: {},
  },
  collectionViewRxDetails: {
    loading: false,
    data: {},
    error: {},
  },
  collectionListCount: {
    loading: false,
    data: {},
    error: {},
  },
  updateCollectData: {
    loading: false,
    data: {},
    error: {},
  },
  addAndUpdateNote: {
    loading: false,
    data: {},
    error: {},
  },
  deleteSingleNote: {
    loading: false,
    data: {},
    error: {},
  },
  collectAndRemoveData: {
    loading: false,
    data: {},
    error: {},
  },
  collectedAndRemovedData: {
    loading: false,
    data: {},
    error: {},
  },
  collectMarkAsUrgentData: {
    loading: false,
    data: {},
    error: {},
  },
  createRxDetails: {
    loading: false,
    data: {},
    error: {},
  },
  createChaseUpDetails: {
    loading: false,
    data: {},
    error: {},
  },
  printCollectionList: {
    loading: false,
    data: [],
  },
};

export const CollectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_COLLECTION_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_COLLECTION_LIST: {
      let oldList = state?.collectionRxList?.data;
      return {
        ...state,
        collectionRxList: {
          loading: true,
          data: (action?.payload?.offset > 0 && !action?.payload?.is_page_change) ? oldList : {},
          error: "",
          success: false
        },
      };
    }
    case SUCCESS_GET_COLLECTION_LIST: {
      let oldList = state?.collectionRxList?.data;
      if (oldList?.list?.length > 0 && !action?.requestPayload?.is_page_change && action?.requestPayload?.offset > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        collectionRxList: {
          loading: false,
          data: oldList,
          error: "",
          success:true
        },
      };
    }
    case ERROR_GET_COLLECTION_LIST: {
      return {
        ...state,
        collectionRxList: {
          loading: false,
          data: {},
          error: "",
          success:false
        },
      };
    }
    case START_GET_COLLECTION_COUNT: {
      let oldList = state?.collectionListCount?.data;
      return {
        ...state,
        collectionListCount: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_COLLECTION_COUNT: {
      let oldList = state?.collectionListCount?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        collectionListCount: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_COLLECTION_COUNT: {
      return {
        ...state,
        collectionListCount: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_DELETE_COLLECTION: {
      return {
        ...state,
        deleteCollectionRx: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_COLLECTION_GROUP: {
      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      oldList.urgent_count = oldList?.urgent_count - 1;
      return {
        ...state,
        deleteCollectionRx: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_COLLECTION_GROUP: {
      return {
        ...state,
        deleteCollectionRx: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_COLLECTION_DETAIL: {
      let oldList = state?.collectionViewRxDetails?.data;
      return {
        ...state,
        collectionViewRxDetails: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_COLLECTION_DETAIL: {
      let oldList = state?.collectionViewRxDetails?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        collectionViewRxDetails: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_COLLECTION_DETAIL: {
      return {
        ...state,
        collectionViewRxDetails: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_UPDATE_COLLECT_DATA: {
      return {
        ...state,
        updateCollectData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_COLLECT_DATA: {
      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updateCollectData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_COLLECT_DATA: {
      return {
        ...state,
        updateCollectData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_ADD_AND_UPDATE_NOTE: {
      return {
        ...state,
        addAndUpdateNote: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_ADD_AND_UPDATE_NOTE: {
      let oldData = state?.collectionRxList?.data;
      const noteVal =
        action?.payload?.data?.note !== undefined
          ? action?.payload?.data?.note
          : typeof action?.payload?.data === "string"
          ? action?.payload?.data
          : action?.payload?.note;

      let updatedList = oldData?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            note: noteVal !== undefined ? noteVal : item?.note,
          };
        }
        return item;
      });

      return {
        ...state,
        addAndUpdateNote: {
          loading: false,
          data: action.payload,
          error: {},
        },
        collectionRxList: {
          ...state?.collectionRxList,
          data: {
            ...oldData,
            list: updatedList,
          },
        },
      };
    }
    case ERROR_ADD_AND_UPDATE_NOTE: {
      return {
        ...state,
        addAndUpdateNote: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_NOTE: {
      return {
        ...state,
        deleteSingleNote: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_NOTE: {
      let oldData = state?.collectionRxList?.data;
      let updatedList = oldData?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            note: null,
          };
        }
        return item;
      });

      return {
        ...state,
        deleteSingleNote: {
          loading: false,
          data: action.payload,
          error: {},
        },
        collectionRxList: {
          ...state?.collectionRxList,
          data: {
            ...oldData,
            list: updatedList,
          },
        },
      };
    }
    case ERROR_DELETE_NOTE: {
      return {
        ...state,
        deleteSingleNote: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_COLLECTED_AND_REMOVED_MEDICATION: {
      return {
        ...state,
        collectedAndRemovedData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_COLLECTED_AND_REMOVED_MEDICATION: {
      let tempObjectData = state?.collectionRxList?.data;
      if (action.payload?.data.is_removed === true) {
        tempObjectData.list = tempObjectData?.list?.filter(
          (item) => item?.id != action?.id
        );
        tempObjectData.filterd_record = tempObjectData?.filterd_record - 1;
      }

      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        collectedAndRemovedData: {
          loading: false,
          data: action.payload,
          error: {},
        },
        collectionRxList: {
          ...state?.collectionRxList,
          data: tempObjectData,
        },
      };
    }
    case ERROR_COLLECTED_AND_REMOVED_MEDICATION: {
      return {
        ...state,
        collectedAndRemovedData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case RESET_COLLECTED_AND_REMOVED_MEDICATION: {
      return {
        ...state,
        collectedAndRemovedData: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_COLLECT_AND_REMOVE_MEDICATION: {
      return {
        ...state,
        collectAndRemoveData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_COLLECT_AND_REMOVE_MEDICATION: {
      let tempObjectData = state?.collectionRxList?.data;
      if (action.payload?.data.is_removed === true) {
        tempObjectData.list = tempObjectData?.list?.filter(
          (item) => item?.id != action?.id
        );
        tempObjectData.filterd_record = tempObjectData?.filterd_record - 1;
      }

      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        collectAndRemoveData: {
          loading: false,
          data: action.payload,
          error: {},
        },
        collectionRxList: {
          ...state?.collectionRxList,
          data: tempObjectData,
        },
      };
    }
    case ERROR_COLLECT_AND_REMOVE_MEDICATION: {
      return {
        ...state,
        collectAndRemoveData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DRUG_NAME_UPDATE: {
      return {
        ...state,
        collectedAndRemovedData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DRUG_NAME_UPDATE: {
      let tempObjectData = state?.collectionRxList?.data;
      // let oldList = state?.patientList?.data;
      // oldList.list = oldList?.list?.map((item) => {
      //   if (item?.id == action?.id) {
      //     return {
      //       ...item,
      //       ...action?.payload?.data,
      //     };
      //   } else {
      //     return item;
      //   }
      // });

      return {
        ...state,
        collectedAndRemovedData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DRUG_NAME_UPDATE: {
      return {
        ...state,
        collectedAndRemovedData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_COLLECT_MARK_AS_URGENT: {
      return {
        ...state,
        collectMarkAsUrgentData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_COLLECT_MARK_AS_URGENT: {
      let tempObjectData = state?.collectionRxList;
      tempObjectData = {
        ...tempObjectData,
        data: {
          ...tempObjectData?.data,
          list: tempObjectData?.data?.list?.map((item) => {
            if (item?.id == action?.id) {
              item.status = item.status == 1 ? 0 : 1;
              return item;
            } else {
              return item;
            }
          }),
        },
      };
      return {
        ...state,
        collectMarkAsUrgentData: {
          loading: false,
          data: {},
          error: {},
        },
        collectionRxList: tempObjectData,
      };
    }
    case ERROR_COLLECT_MARK_AS_URGENT: {
      return {
        ...state,
        collectMarkAsUrgentData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_CREATE_RX: {
      return {
        ...state,
        createRxDetails: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_RX: {
      return {
        ...state,
        createRxDetails: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_RX: {
      return {
        ...state,
        createRxDetails: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_CREATE_CHASEUP: {
      return {
        ...state,
        createChaseUpDetails: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_CHASEUP: {
      let oldList = state?.collectionRxList?.data;
      if (action.chaseUpActiveStatus === false) {
        oldList.list = oldList?.list?.map((item) => {
          if (item?.id == action?.payload.id) {
            if (action?.payload?.type == "mark_as_reopen") {
              item.reorder_date.push(new Date());
              item.chase_up_status = false;
            } else if (action?.payload?.type == "ready_to_collect") {
              item.ready_to_collect = true;
              item.chase_up_status = false;
            } else {
              item.chase_up_status = true;
              item.ready_to_collect = false;
            }

            return { ...item, ...action?.payload?.data };
          } else {
            return item;
          }
        });
      } else {
        oldList.list = oldList?.list?.filter((item) => {
          return item?.id !== action?.payload.id;
        });
      }
      return {
        ...state,
        createChaseUpDetails: {
          loading: false,
          data: action.payload,
          error: {},
        },
        collectionRxList: {
          ...state?.collectionRxList,
          data: oldList,
        },
      };
    }
    case ERROR_CREATE_CHASEUP: {
      return {
        ...state,
        createChaseUpDetails: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_PRINT_COLLECTION_LIST: {
      return {
        ...state,
        printCollectionList: {
          loading: true,
          data: [],
        },
      };
    }
    case SUCCESS_GET_PRINT_COLLECTION_LIST: {
      return {
        ...state,
        printCollectionList: {
          loading: false,
          data: action?.payload?.data?.list,
        },
      };
    }
    case ERROR_GET_PRINT_COLLECTION_LIST: {
      return {
        ...state,
        printCollectionList: {
          loading: false,
          data: [],
        },
      };
    }
    case START_UPDATE_FIELD_COLLECTION: {
      return {
        ...state,
        collectionRxList: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_FIELD_COLLECTION: {
      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        collectionRxList: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_FIELD_COLLECTION: {
      return {
        ...state,
        collectionRxList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case SUCCESS_UPDATE_FIELD_PATIENT: {
      let oldData = state?.collectionRxList?.data;
      if (oldData?.list?.length > 0) {
        let updatedList = oldData?.list?.map((item) => {
          if (
            item?.patient_id == action?.id ||
            item?.id == action?.id ||
            item?.patient?.id == action?.id
          ) {
            const newDob =
              action?.payload?.data?.dob !== undefined
                ? action?.payload?.data?.dob
                : action?.payload?.dob !== undefined
                ? action?.payload?.dob
                : item?.dob;
            return {
              ...item,
              dob: newDob,
              ...(item?.patient && {
                patient: {
                  ...item.patient,
                  dob: newDob,
                },
              }),
            };
          }
          return item;
        });
        return {
          ...state,
          collectionRxList: {
            ...state?.collectionRxList,
            data: {
              ...oldData,
              list: updatedList,
            },
          },
        };
      }
      return state;
    }
    case START_ARCHIVE_COLLECTION: {
      return {
        ...state,
        deleteCollectionRx: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_ARCHIVE_COLLECTION: {
      let oldList = state?.collectionRxList?.data;
      oldList.list = oldList?.list?.filter(
        (item) => item?.id != action?.id?.id
      );
      oldList.filterd_record = oldList?.filterd_record - 1;
      oldList.urgent_count = oldList?.urgent_count - 1;

      return {
        ...state,
        deleteCollectionRx: {
          loading: false,
          data: action.id,
          error: {},
        },
      };
    }
    case ERROR_ARCHIVE_COLLECTION: {
      return {
        ...state,
        deleteCollectionRx: {
          loading: false,
          data: {},
          error: action.id,
        },
      };
    }
    case START_COMPLETE_COLLECTION: {
      return {
        ...state,
        completeCollectionRx: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_COMPLETE_COLLECTION: {
      // let oldList = state?.collectionRxList?.data;
      // oldList.list = oldList?.list?.filter(
      //   (item) => item?.id != action?.id?.id
      // );
      // oldList.filterd_record = oldList?.filterd_record - 1;
      // oldList.urgent_count = oldList?.urgent_count - 1;
      let tempObjectData = state?.collectionRxList;

      tempObjectData = {
        ...tempObjectData,
        data: {
          ...tempObjectData?.data,
          list: tempObjectData?.data?.list?.map((item) => {
            if (item?.id == action?.id?.id) {
              const currentDate = new Date();
              item.completed_at =
                item.completed_at == null ? currentDate.toDateString() : null;
              return item;
            } else {
              return item;
            }
          }),
        },
      };
      return {
        ...state,
        completeCollectionRx: {
          loading: false,
          data: action.id,
          error: {},
        },
        collectionRxList: tempObjectData,
      };
    }
    case ERROR_COMPLETE_COLLECTION: {
      return {
        ...state,
        completeCollectionRx: {
          loading: false,
          data: {},
          error: action.id,
        },
      };
    }

    default: {
      return state || initialState;
    }
  }
};
